import { render } from "./sampleToggleActive.vue?vue&type=template&id=79c70c91&scoped=true"
import script from "./sampleToggleActive.vue?vue&type=script&lang=js"
export * from "./sampleToggleActive.vue?vue&type=script&lang=js"

import "./sampleToggleActive.vue?vue&type=style&index=0&id=79c70c91&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pablo Sastre\\OneDrive\\Escritorio\\BAIPManagerTestv2\\BaipMarket.Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c70c91"]])

export default __exports__